const getNonNullableList = <T>(list: T[] | null | undefined) => {
  return list?.flatMap((x) => (x ? [x] : [])) ?? [];
};

export default getNonNullableList;
